require('./common/recaptchav3');
// require('./common/currentLocale');
// require('./common/validator');
// require('./common/accordion');
// require('./common/tabs');
// require('./components/dropdown-select-lang');